import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AveragePagesUsed from "../../../../../CustomerDashboard/AveragePagesUsed/AveragePagesUsed";
import Loader from "../../../../../shared/loader/Loader";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { SUCCESS } from "../../../../../../constants/AppConstants";

const PrintHistory = ({ getUserPrintHistory }) => {
    const { loading, error } = getUserPrintHistory;
    const history = getUserPrintHistory?.printHistory
    const { t } = useTranslation("CSAgenttranslation");
    const TABS = {
        'BROTHER_PLUS_PRINT_HISTORY': 'BROTHER_PLUS_PRINT_HISTORY'
    }
    const [activeTab, setActiveTab] = useState((history?.length > 0)
        ? history[0]?.deviceId
        : null);

    useEffect(() => {
        if (history && history?.actionStatus?.toUpperCase() === SUCCESS) {
            if ((history?.printHistoryDetails?.length > 0)) {
                setActiveTab(history?.printHistoryDetails[0]?.deviceId);
            } else {
                setActiveTab(TABS.BROTHER_PLUS_PRINT_HISTORY);
            }
        }
    }, [TABS.BROTHER_PLUS_PRINT_HISTORY, history]);

    if (loading) {
        return <Loader />;
    }
    if (error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.PRINT_HISTORY_NOT_FOUND")}</div>;
    }

    return (
        <div className="overview-container customer-details-wrapper mt-40">
            <div className="tab-btn-wrapper">
                <div>
                    <Nav tabs>
                        {(history?.printHistoryDetails?.length > 0) ?
                            history?.printHistoryDetails.map((devicePrintHistory) => (
                                (devicePrintHistory !== null) ?
                                    <NavItem>
                                        <NavLink active={activeTab === devicePrintHistory.deviceId} onClick={() => setActiveTab(devicePrintHistory.deviceId)}>
                                            {devicePrintHistory.serialNumber}
                                        </NavLink>
                                    </NavItem> : null
                            )) :
                            <NavItem>
                                <NavLink active={activeTab === TABS.BROTHER_PLUS_PRINT_HISTORY} onClick={() => setActiveTab(TABS.BROTHER_PLUS_PRINT_HISTORY)}>
                                    {t('CUSTOMER_DASHBOARD.TAB_ITEMS.BROTHERPLUS_PRINT_HISTORY')}
                                </NavLink>
                            </NavItem>
                        }
                    </Nav>
                </div>
            </div>
            <div className="device-info-tab-contens">
                <TabContent activeTab={activeTab}>
                    {
                        (history?.printHistoryDetails?.length > 0) ?
                            history?.printHistoryDetails.map((devicePrintHistory) => (
                                (devicePrintHistory !== null) ?
                                    <TabPane tabId={devicePrintHistory.deviceId}>
                                        <div>
                                            <AveragePagesUsed printHistoryResult={devicePrintHistory.history} source={"brother-plus"} />

                                        </div>
                                    </TabPane> : null
                            )) :
                            <TabPane tabId={TABS.BROTHER_PLUS_PRINT_HISTORY}>
                                <div className="email-log-error">{t("ERROR_MESSAGES.PRINT_HISTORY_NOT_FOUND")}</div>
                            </TabPane>
                    }
                </TabContent>
            </div>
        </div>
    )
}

export default PrintHistory;